/* =====================================================
   BIN IJAZ - CUSTOM BUNDLE EXPERIENCE
===================================================== */

document.addEventListener("DOMContentLoaded", () => {

    const BundleApp = {

        requiredQty: 3,
        discount: 13,
        selectedProducts: 0,

        init() {

            if (!window.location.pathname.includes("/pages/bundles"))
                return;

            console.log("Bundle App Started");

            this.bindBundleButtons();
            this.createFooter();
            this.watchSelection();
            this.bindCheckoutButton();

        },

        bindBundleButtons() {

            document.querySelectorAll(".bundle-btn").forEach(btn => {

                btn.addEventListener("click", () => {

                    document.querySelectorAll(".bundle-btn")
                        .forEach(b => b.classList.remove("active"));

                    btn.classList.add("active");

                    this.requiredQty = parseInt(btn.dataset.qty);
                    this.discount = parseInt(btn.dataset.discount);

                   /* document.getElementById("bundle-message").innerHTML =
                        `Select any <strong>${this.requiredQty}</strong> products below to get <strong>${this.discount}% OFF</strong>`;*/

                    this.updateFooter();
                    this.limitSelection();

                });

            });

        },

        createFooter() {

            if(document.getElementById("custom-bundle-bar")) return;

            document.body.insertAdjacentHTML("beforeend",`

                <div id="custom-bundle-bar">

                    <div class="bundle-left">

                        <div id="bundle-images"></div>

                        <div class="bundle-text">

                            <strong id="bundle-count">
                                0 of ${this.requiredQty} Selected
                            </strong>

                            <span id="bundle-remaining">
                                Select ${this.requiredQty} more product(s)
                            </span>

                        </div>

                    </div>

                    <button id="bundle-cart-btn" disabled>
                        Add to Cart
                    </button>

                </div>

            `);

        },

        watchSelection() {

            setInterval(() => {

                const products = document.querySelectorAll(
                    ".bndlr-mnm-selected-products .bndlr-product"
                );

                this.selectedProducts = products.length;

                this.updateFooter();
                this.limitSelection();

            }, 200);

        },

        updateFooter() {

            const count = this.selectedProducts;
            const remaining = this.requiredQty - count;

            document.getElementById("bundle-count").innerHTML =
                `${count} of ${this.requiredQty} Selected`;

            document.getElementById("bundle-remaining").innerHTML =
                remaining > 0
                    ? `Select ${remaining} more product(s)`
                    : `Bundle Ready`;

            const cartBtn = document.getElementById("bundle-cart-btn");

            if (count === this.requiredQty) {
                cartBtn.disabled = false;
                cartBtn.classList.add("ready");
                cartBtn.innerHTML = "Add to Cart";
            } else {
                cartBtn.disabled = true;
                cartBtn.classList.remove("ready");
                cartBtn.innerHTML = "Complete Bundle";
            }

        },

        limitSelection() {

            const addButtons = document.querySelectorAll(".bndlr-add-to-bundle");

            if (this.selectedProducts >= this.requiredQty) {

                addButtons.forEach(btn => {

                    btn.style.pointerEvents = "none";
                    btn.style.opacity = ".35";
                    btn.innerHTML = "Maximum Selected";

                });

            } else {

                addButtons.forEach(btn => {

                    btn.style.pointerEvents = "auto";
                    btn.style.opacity = "1";
                    btn.innerHTML = "Add to bundle";

                });

            }

        },

        bindCheckoutButton() {

    document.addEventListener("click", (e) => {

        if (e.target.id !== "bundle-cart-btn") return;

        if (this.selectedProducts !== this.requiredQty) {

            alert(`Please select exactly ${this.requiredQty} products.`);
            return;

        }

        const target = document.querySelector(".bndlr-add-bundle-to-cart");

        if (target) {

            target.scrollIntoView({
                behavior: "smooth",
                block: "center"
            });

            // Highlight it for the customer
            target.style.transition = "all .3s";
            target.style.boxShadow = "0 0 20px #FBBB44";

            setTimeout(() => {
                target.style.boxShadow = "";
            },1500);

        } else {

            alert("Bundler Add to Cart button not found.");

        }

    });

}

    };

    BundleApp.init();

});